type Attrs = Record<string, string>;
type Child = string | Node | null | undefined;

/**
 * Tiny, typed `h()` helper — creates an element, applies attributes/classes,
 * and appends children (strings become text nodes). Keeps the render code
 * declarative without pulling in a UI framework.
 */
export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  children: Child[] = []
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);

  for (const [key, value] of Object.entries(attrs)) {
    if (key === 'class') {
      el.className = value;
    } else {
      el.setAttribute(key, value);
    }
  }

  for (const child of children) {
    if (child === null || child === undefined) continue;
    el.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }

  return el;
}
